import styled from 'styled-components'

export const StyledContainer = styled.div`
  margin-bottom: 50px;
`

export const StyledTitleWrapper = styled.div`
  border-bottom: 1px solid #dbdbdb;

  ${({ $isActive }) =>
    $isActive &&
    `
    padding-top: 25px;
  `}
`

export const StyledEmptyMessageWrapper = styled.div`
  padding: 30px 0 0;

  p {
    text-align: center;
  }
`
